import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0935ab98&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=ts"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=0935ab98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0935ab98",
  null
  
)

export default component.exports